/**
* DevExpress HTML/JS Reporting (designer\controls\metadata\xrPagebreak.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { formattingRuleLinks } from './properties/formattingRulesLink';
import { location } from './properties/metadata';
import { baseControlProperties } from './properties/metadataGroups';
import { truncatedControlScripts } from './properties/scriptMetadata';
export const pageBreakSerializationsInfo = [location, formattingRuleLinks, truncatedControlScripts].concat(baseControlProperties);
